import React, { Fragment } from 'react';
import SectionRoutine from 'components/templates/SectionRoutine/SectionRoutine';
import { appStructure } from 'helpers/navigationHelper';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import SectionTips from 'components/templates/SectionTips/SectionTips';
import SwipeableView from 'components/molecules/SwipeableView/SwipeableView';
import { Loadable } from 'dataLayer/recoil/Loadable';
import { restAndRejuvenateTipsAtom } from 'dataLayer/recoil/pages/sections/atoms';
import { exerciseRoutineEveningSelector } from 'dataLayer/recoil/pages/rest/selectors';

const RestTips = (props) => {
  const { data } = props;

  return (
    <Fragment>
      <SwipeableView id="swipeable-tips">
        {data.map((item) => (
          <SectionTips {...item} />
        ))}
      </SwipeableView>
    </Fragment>
  );
};

const ExerciseRoutine = (props) => {
  const { data } = props;

  return (
    <Fragment>
      <SwipeableView id="swipeable-morning">
        {data.map((exerciseRoutineData) => {
          return <SectionRoutine {...exerciseRoutineData} />;
        })}
      </SwipeableView>
    </Fragment>
  );
};

export default function RestSection(props) {
  let { path } = useRouteMatch();

  const subsections = appStructure.sections[4].subsections;

  // const icon = (
  //   <Illustration height="60%" width="60%">
  //     <BedTime />
  //   </Illustration>
  // );

  return (
    <Fragment>
      <Switch>
        <Route exact path={path}>
          <Redirect
            to={{
              pathname: subsections[0].route,
              state: { from: 'eat fresh initial' },
            }}
          />
        </Route>
        <Route
          path={subsections[0].route}
          render={() => (
            <Loadable
              value={exerciseRoutineEveningSelector}
              component={ExerciseRoutine}
            />
          )}
        />
        {/* <Route path={subsections[1].route}>
          <Fragment>
            <TraitDetailsGroup {...data.profile}>{[icon]}</TraitDetailsGroup>
          </Fragment>
        </Route> */}
        <Route
          path={subsections[1].route}
          render={() => (
            <Loadable value={restAndRejuvenateTipsAtom} component={RestTips} />
          )}
        />
      </Switch>
    </Fragment>
  );
}
